import { createFeatureSelector, createSelector } from "@ngrx/store";
import { each } from "lodash";
import { CriterionsTemplateModel } from "../_models";
import { CriterionsTemplateState } from "../_reducers";

export const selectCriterionsTemplateState = createFeatureSelector<CriterionsTemplateState>('criterions-template');

export const selectIsLoading = createSelector(
    selectCriterionsTemplateState,
    state => state.isLoading
)

export const selectTotal = createSelector(
    selectCriterionsTemplateState,
    state => state.total
)

export const selectTemplate = (id: number) => createSelector(
    selectCriterionsTemplateState,
    state => state.entities[id]
)

export const selectCriterionsTemplates = createSelector(
    selectCriterionsTemplateState,
    state => {
        const items: CriterionsTemplateModel[] = [];
        each(state.entities, el => items.push(el));
        return items.sort((a, b) => (b.id - a.id));
    }
)